"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const index_1 = require("./index");
exports.default = (props) => ((0, jsx_runtime_1.jsx)(ContentWrapper, { children: (0, jsx_runtime_1.jsx)(index_1.OfflineInfoCard, { translations: props.translations }, void 0) }, void 0));
const Content = styled_components_1.default.div `
  flex: 2;
`;
const ContentWrapper = (0, styled_components_1.default)(Content) `
  width: 100%;
  height: 100%;
  margin-top: 35px;
  padding-right: 70px;
  padding-left: 40px;
  overflow: auto;

  @media (max-width: 1024px) {
    margin: ${(props) => props.customMobileMargin ? props.customMobileMargin : "25px 0 0 0"};
    overflow: inherit;
    padding: 0 20px;
  }

  @media (min-width: 1025px) and (max-width: 1300px) {
    padding: 0 10px 0 10px;
  }
`;
//# sourceMappingURL=OfflineInfo.js.map